import { create } from 'zustand';
import {
  Stylist,
  Gender,
  PricingTier,
  AgeRange,
  SessionType,
  City,
} from '@/shared/types/generated';
import { Expertise, StylingPreference } from '@/shared/types/stylist';

export interface BookingDetails {
  sessionDuration: number;
  selectedDate: Date | null;
  selectedTime: number | null;
  reason: string;
  additionalDetails?: string;
  sessionType: SessionType;
}

export interface FilterState {
  priceTier: PricingTier[];
  expertise: Expertise[];
  stylingPreferences: StylingPreference[];
  age: AgeRange[];
  gender: Gender | null;
  sessionType: SessionType | null;
  availableInPerson: boolean | null;
  cities: City[];
}

interface ExploreState {
  selectedStylist: Stylist | null;
  setSelectedStylist: (stylist: Stylist) => void;
  booking: BookingDetails;
  setBooking: (booking: Partial<BookingDetails>) => void;
  resetBooking: () => void;
  userHasPaymentMethod: boolean;
  setUserHasPaymentMethod: (userHasPaymentMethod: boolean) => void;
  filters: FilterState;
  setFilters: (filters: Partial<FilterState>) => void;
  resetFilters: () => void;
}

const initialBookingState: BookingDetails = {
  sessionDuration: 60,
  selectedDate: new Date(),
  selectedTime: null,
  reason: 'No Preference',
  additionalDetails: '',
  sessionType: SessionType.Video,
};

const initialFilterState: FilterState = {
  priceTier: [],
  expertise: [],
  stylingPreferences: [],
  age: [],
  gender: null,
  sessionType: null,
  availableInPerson: null,
  cities: [],
};

const useExploreStore = create<ExploreState>((set) => ({
  selectedStylist: null,
  setSelectedStylist: (stylist) => set({ selectedStylist: stylist }),
  booking: initialBookingState,
  setBooking: (booking) =>
    set((state) => ({
      booking: { ...state.booking, ...booking },
    })),
  resetBooking: () => set({ booking: initialBookingState }),
  setUserHasPaymentMethod: (userHasPaymentMethod) =>
    set({ userHasPaymentMethod }),
  userHasPaymentMethod: false,
  filters: initialFilterState,
  setFilters: (filters) =>
    set((state) => ({
      filters: { ...state.filters, ...filters },
    })),
  resetFilters: () => set({ filters: initialFilterState }),
}));

export default useExploreStore;
